// See Netx.Collections.StorageLocations `getLocationTypes` parser for how typeIds/labels/types get set
export let typeIds = {};
export let typeLabels = {};

export default {typeIds, typeLabels};
